import { Timestamp } from 'firebase/firestore';

export type InteractionType =
  | 'cards'
  | 'meal'
  | 'visit'
  | 'text'
  | 'service'
  | 'other';

export interface Interaction {
  date: Date;
  type: InteractionType;
  notes: string;
}

export interface Contact {
  id: string;
  name: string;
  phoneNumber: string;
  email: string;
  active: boolean;
  howDidWeMeet: string;
  bibleStudy: boolean;
  baptism: boolean;
  pointOfContact: string;
  address: string;
  interactions: Interaction[];
}

export type BibleVersion = 'ESV' | 'WEB' | 'KJV' | 'ASV';

export function isValidBibleVersion(version: string): version is BibleVersion {
  return (
    version === 'ESV' ||
    version === 'WEB' ||
    version === 'KJV' ||
    version === 'ASV'
  );
}

export interface DeviceToken {
  token: string;
  deviceId: string; // Unique identifier for the device
  lastUsed: Date; // When this token was last used
}

export interface NotificationSettings {
  tokens?: DeviceToken[];
  optedIn?: boolean;
  time?: string | null;
  /** IANA timezone in which the daily notification time should be interpreted. */
  timeZone?: string;
}

export interface UserProfile {
  firstName?: string;
  isAdmin?: boolean;
  defaultBibleVersion?: string;
  defaultFontSize?: string;
  notifications?: NotificationSettings;
}

export interface UserData extends UserProfile {
  completedDays: {
    [year: string]: { date: Timestamp; dayNumber: number }[]; // Array of day numbers (1-365) for each year
  };
}
